import React, { useMemo, useState } from 'react';

import { CarBadges } from 'components/views/ProductItem/components/CarBadges';
import { ListItemProps } from 'components/List/ListItem';
import { Button, ButtonType, ButtonVariant } from 'components/Button';

import { WrappedList } from '../WrappedList';

import styles from './Equipment.module.scss';

interface IEquipment {
  badges: Array<string>;
  listItems: Array<ListItemProps>;
  vehicleType: string;
}

const PAGINATE_NUMBER = 16;

export const Equipment: React.VFC<IEquipment> = ({ badges, listItems, vehicleType }) => {
  const [listItemToShow, setListItemToShow] = useState(1);

  const listItemsPaginated = useMemo(
    () => listItems.slice(0, listItemToShow * PAGINATE_NUMBER),
    [listItemToShow, listItems]
  );

  return (
    <div className={styles.equipment}>
      <h2 id="equipment" className={styles.title}>
        Utrustning
      </h2>
      <div className={styles['content-wrapper']}>
        <div className={styles['badges-wrapper']}>
          {vehicleType === 'MC' ? (
            <p className={styles.badgeParagraph}>{badges}</p>
          ) : (
            <CarBadges badges={badges} />
          )}
        </div>
        <WrappedList items={listItemsPaginated} transparentBg />
        {listItemToShow * PAGINATE_NUMBER < listItems.length ? (
          <div className={styles['more-btn-wrapper']}>
            <Button
              variant={ButtonVariant.GhostInverted}
              type={ButtonType.Button}
              onClick={() => setListItemToShow((prev) => prev + 1)}
            >
              Visa mer
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
